// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-footer {
  gap: 10px;
}

.dialog-content,
.table-scroll {
  scrollbar-width: thin;
  scrollbar-color: #cfd7e0 transparent;
}

.dialog-content::-webkit-scrollbar,
.table-scroll::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.dialog-content::-webkit-scrollbar-thumb,
.table-scroll::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #cfd7e0;
}

.dialog-table-skeleton td {
  padding: 14px 12px;
}

.dialog-table-skeleton span {
  display: block;
  height: 12px;
  min-width: 42px;
  border-radius: 5px;
  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);
  background-size: 400% 100%;
  animation: dialog-skeleton 1.35s ease infinite;
}

@keyframes dialog-skeleton {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-featured-product/add-featured-product.component.overrides.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,oCAAA;AACF;;AAEA;;EAEE,UAAA;EACA,WAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,8CAAA;AACF;;AAEA;EACE;IACE,2BAAA;EACF;EAEA;IACE,wBAAA;EAAF;AACF","sourcesContent":[".dialog-footer {\n  gap: 10px;\n}\n\n.dialog-content,\n.table-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #cfd7e0 transparent;\n}\n\n.dialog-content::-webkit-scrollbar,\n.table-scroll::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n.dialog-content::-webkit-scrollbar-thumb,\n.table-scroll::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  background: #cfd7e0;\n}\n\n.dialog-table-skeleton td {\n  padding: 14px 12px;\n}\n\n.dialog-table-skeleton span {\n  display: block;\n  height: 12px;\n  min-width: 42px;\n  border-radius: 5px;\n  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);\n  background-size: 400% 100%;\n  animation: dialog-skeleton 1.35s ease infinite;\n}\n\n@keyframes dialog-skeleton {\n  from {\n    background-position: 100% 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
